<template>
  <div class="pageloader is-active">
    <span class="title has-text-white">
      Verificando token...
    </span>
  </div>
</template>

<script>
export default {
  name: 'VerifyStatusAccountToken',
  async mounted() {
    const router = this.$router;
    const route = this.$route;

    if (!route.query.token) router.push({ name: 'Landing' });

    sessionStorage.setItem('customer_access_token', route.query.token);

    await this.$store.dispatch(
      'customers/verifyStatusAccountToken',
      route.query.token,
    );

    router.push({ name: 'StatusAccountDetail' });
  },
};
</script>
